import { ChevronLeft } from 'lucide-react';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import { isRenderedInsideEmbed } from 'utils/isRenderedInsideEmbed';
import { Button } from '../ui/button';
import { useSelector } from 'react-redux';
import { selectLoadingStateFromCart } from 'store/cartSlice/selectors';

interface TicketSalePageHeaderProps
  extends React.HTMLAttributes<HTMLButtonElement> {}

const TicketSalePageHeader: React.FC<TicketSalePageHeaderProps> = props => {
  const { t } = useTranslation();
  const { eventSlug } = useParams();
  const isLoading = useSelector(selectLoadingStateFromCart);

  if (isRenderedInsideEmbed || isLoading) return null;

  return (
    <Button asChild size="sm" variant="outline" {...props}>
      <Link to={`/event/${eventSlug}`}>
        <ChevronLeft />
        {t('ticketSale.eventDetails')}
      </Link>
    </Button>
  );
};

export default memo(TicketSalePageHeader);
